import * as React from 'react';
import { SVGProps } from 'react';

const IconPlaySizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path d="M15 8 3 15V1l12 7Z" />
  </svg>
);
export default IconPlaySizeS;
